import {Naja} from "naja";
import showLoader from "../helpers/showLoader";
import ClassicExtension from "./ClassicExtension";

export default class ConfirmExtension extends ClassicExtension {

    public initialize(naja: Naja): void {
        super.initialize(naja)
        naja.uiHandler.addEventListener('interaction', e => {
            const $el = $(e.detail.element);
            if ($el.data('confirm')) {
                this.processConfirm(e, <JQuery>$el);
            }
        });
    }

    protected init($root: JQuery): void {
        $root.find("[data-confirm]:not(.ajax)").each((i,el)=>{
            $(el).on('click',e => this.processConfirm(e, $(e.currentTarget)));
        })
    }

    private processConfirm(e, $target: JQuery): void {
        const form = $target.closest('form')[0];
        const question = $target.data('confirm');
        const yes = $target.data('confirm-yes');
        const no = $target.data('confirm-no');
        const confirmed = $target.data('confirmed');

        const loaderTargetClosest = $target.data('loader-target-closest');

        if (form && !window.Nette.validateForm(form, true)) {
            return;
        }

        if (question && !confirmed) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const $modal = $('[data-confirm-modal-template]');
            const $confirmText = $('[data-confirm-text]', $modal);
            const $confirmYes = $('[data-confirm-yes]', $modal);
            const $confirmNo = $('[data-confirm-no]', $modal);

            $confirmYes.text($confirmYes.data('confirm-default-yes'));
            if (yes) {
                $confirmYes.text(yes);
            }

            $confirmNo.text($confirmNo.data('confirm-default-no'));
            if (no) {
                $confirmNo.text(no);
            }

            $confirmText.html(question);
            $modal.modal('show');

            $('[data-confirm-action]', $modal).off('click.confirm').on('click.confirm', () => {
                $target.data('confirmed', true);

                if(loaderTargetClosest) {
                    showLoader($target.closest(loaderTargetClosest));
                }

                $modal.modal('hide');
                $target[0].click();
            });
        }
    }



}
